<h2>Let's Add a Bit on Your Waste Stream</h2>
<form [formGroup]="form">
  <div class="column-2">
    <div class="col">
      <div class="input-container">
        <label>
          Waste Stream Name
          <mat-icon-button
            mat-icon-button
            class="btn-hint"
            matTooltip="Provide the common name of the major component or substance that most accurately describes the waste."
          >
            <mat-icon class="help-icon">help</mat-icon>
          </mat-icon-button></label
        >
        <mat-form-field appearance="outline">
          <input maxlength="100" matInput formControlName="name" />
          <mat-error class="error" *ngIf="errorHandling('name', 'required')">
            Waste Stream Name is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="input-container">
        <label>Type of Waste</label>
        <mat-radio-group fxLayout="column" formControlName="wasteType">
          <mat-radio-button value="industrial-process"
            >Industrial Process Waste
          </mat-radio-button>
          <mat-radio-button value="pollution-control"
            >Pollution Control Waste
          </mat-radio-button>
        </mat-radio-group>
        <div class="mat-form-field-subscript-wrapper">
          <mat-error *ngIf="errorHandling('wasteType', 'required')">
            Type of Waste is <strong>Required</strong>
          </mat-error>
        </div>
      </div>

      <div class="input-container">
        <label>Physical State</label>
        <mat-radio-group fxLayout="column" formControlName="physicalState">
          <mat-radio-button
            *ngFor="let physicalState of physicalStates"
            [value]="physicalState.value"
            (change)="physicalStateChange($event)"
          >
            {{ physicalState.label }}
          </mat-radio-button>
        </mat-radio-group>
        <div class="mat-form-field-subscript-wrapper">
          <mat-error *ngIf="errorHandling('physicalState', 'required')">
            Physical State is <strong>Required</strong>
          </mat-error>
        </div>
      </div>

      <div class="input-container free-liquids">
        <label
          >Does the Waste Contain Free Liquids?
          <mat-icon-button
            mat-icon-button
            class="btn-hint"
            matTooltip="Determine if there are free liquids in the waste
             (Paint Filter Test). Mark NO if the waste passes the test (no free liquids present).
             Mark YES if the waste fails the test (detecting the presence of free liquids)."
          >
            <mat-icon class="help-icon">help</mat-icon>
          </mat-icon-button>
        </label>
        <mat-radio-group
          fxLayout="column"
          formControlName="containsFreeLiquids"
          [disabled]="disableFreeliquids"
        >
          <mat-radio-button [value]="true">Yes</mat-radio-button>
          <mat-radio-button [value]="false">No</mat-radio-button>
          <div class="mat-form-field-subscript-wrapper">
            <mat-error *ngIf="errorHandling('containsFreeLiquids', 'required')">
              Waste Contains Free Liquids is <strong>Required</strong>
            </mat-error>
          </div>
        </mat-radio-group>
      </div>

      <div class="input-container">
        <label>
          % Solids
          <mat-icon-button
            mat-icon-button
            class="btn-hint"
            matTooltip="Determine the amount of solids present in the waste,
            provide as a percentage of the waste as a whole."
          >
            <mat-icon class="help-icon">help</mat-icon>
          </mat-icon-button>
        </label>
        <span>
          Exact Value
          <mat-slide-toggle
            [checked]="isSolidToggle"
            (change)="isSolidToggleChange($event)"
            [disabled]="isSolidToggleEnabled"
          >
          </mat-slide-toggle>
          Range
        </span>
        <div
          fxLayout="row"
          fxLayoutGap="15px"
          fxLayoutAlign="start center"
          *ngIf="!isSolidToggle"
        >
          <div class="input-container">
            <label> Exact % Solids if Known </label>
            <mat-form-field appearance="outline">
              <input matInput formControlName="percentSolids" />
              <mat-error *ngIf="errorHandling('percentSolids', 'required')">
                Percent Solids is <strong>Required</strong>
              </mat-error>
              <mat-error
                *ngIf="
                  errorHandling('percentSolids', 'min') ||
                  errorHandling('percentSolids', 'max') ||
                  errorHandling('percentSolids', 'decimal')
                "
              >
                Must be whole number between 0-100
              </mat-error>
            </mat-form-field>
          </div>
          <mat-checkbox
            *ngIf="false"
            formControlName="percentSolidNotApplicable"
            >N/A
          </mat-checkbox>
        </div>
        <div fxLayout="row" fxLayoutGap="15px" *ngIf="isSolidToggle">
          <div class="input-container no-margin">
            <label> Low end of range </label>
            <mat-form-field appearance="outline">
              <input matInput formControlName="percentSolidsLow" />
              <mat-error *ngIf="errorHandling('percentSolidsLow', 'required')">
                Percent Solids is <strong>Required</strong>
              </mat-error>
              <mat-error
                *ngIf="
                  errorHandling('percentSolidsLow', 'min') ||
                  errorHandling('percentSolidsLow', 'max') ||
                  errorHandling('percentSolidsLow', 'decimal')
                "
              >
                Must be a numeric value between 0-100
              </mat-error>
              <mat-error *ngIf="errorHandling('percentSolidsLow', 'lessThan')">
                Low end of range must be less than high end.
              </mat-error>
            </mat-form-field>
          </div>
          <div class="input-container no-margin">
            <label> High end of range </label>
            <mat-form-field appearance="outline">
              <input matInput formControlName="percentSolidsHigh" />
              <mat-error *ngIf="errorHandling('percentSolidsHigh', 'required')">
                Percent Solids is <strong>Required</strong>
              </mat-error>
              <mat-error
                *ngIf="
                  errorHandling('percentSolidsHigh', 'min') ||
                  errorHandling('percentSolidsHigh', 'max') ||
                  errorHandling('percentSolidsHigh', 'decimal')
                "
              >
                Must be a numeric value between 0-100
              </mat-error>
              <mat-error
                *ngIf="errorHandling('percentSolidsHigh', 'greaterThan')"
              >
                High end of range must be greater than low end.
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <label>
          pH
          <mat-icon-button
            mat-icon-button
            class="btn-hint"
            matTooltip="Indicate the pH of the waste (corrosivity). If the Exact pH is unknown, please enter N/A."
          >
            <mat-icon class="help-icon">help</mat-icon>
          </mat-icon-button>
        </label>
        <span>
          Exact Value
          <mat-slide-toggle
            [checked]="isphToggle"
            (change)="isphToggleChange($event)"
            [disabled]="isphToggleEnabled"
          >
          </mat-slide-toggle>
          Range
        </span>
        <div
          fxLayout="row"
          fxLayoutGap="15px"
          fxLayoutAlign="start center"
          *ngIf="!isphToggle"
        >
          <div class="input-container">
            <label> Exact pH Value if Known </label>
            <mat-form-field appearance="outline">
              <input matInput formControlName="phExact" />
              <mat-error *ngIf="errorHandling('phExact', 'required')">
                pH is <strong>Required</strong>
              </mat-error>
              <mat-error
                *ngIf="
                  errorHandling('phExact', 'min') ||
                  errorHandling('phExact', 'max') ||
                  errorHandling('phExact', 'decimal')
                "
              >
                Must be a numeric value between 0-14
              </mat-error>
            </mat-form-field>
          </div>
          <mat-checkbox
            *ngIf="!isPhNotApplicable"
            formControlName="phNotApplicable"
            >N/A
          </mat-checkbox>
        </div>

        <div *ngIf="isphToggle">
          <label>Range</label>
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-select formControlName="phRange" placeholder="Select Range">
              <mat-option
                *ngFor="let rangeValue of rangeOptions.rangeValues"
                [value]="rangeValue"
              >
                {{ rangeValue }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="errorHandling('phRange', 'required')">
              pH is <strong>Required</strong>
            </mat-error>
          </mat-form-field>
        </div>
        <span
          *ngIf="!(physicalState === 'solid' || physicalState === 'powder')"
        >
          <label>
            Flash Point F
            <mat-icon-button
              mat-icon-button
              class="btn-hint"
              matTooltip="Indicate the temperature at which the waste ignites. If the Flash Point is unknown, please enter N/A."
            >
              <mat-icon class="help-icon">help</mat-icon>
            </mat-icon-button>
          </label>
          <div>
            Exact Value
            <mat-slide-toggle
              [checked]="isFlashPointToggle"
              (change)="isFlashPointToggleChange($event)"
              [disabled]="isFlashPointToggleEnabled"
            >
            </mat-slide-toggle>
            Range
          </div>
          <div
            fxLayout="row"
            fxLayoutGap="15px"
            fxLayoutAlign="start center"
            *ngIf="!isFlashPointToggle"
          >
            <div class="input-container">
              <mat-form-field appearance="outline">
                <input maxlength="5" matInput formControlName="flashPoint" />
                <mat-error *ngIf="errorHandling('flashPoint', 'required')">
                  Flash Point is <strong>Required</strong>
                </mat-error>
                <mat-error
                  *ngIf="
                    errorHandling('flashPoint', 'integer') ||
                    errorHandling('flashPoint', 'pattern')
                  "
                >
                  Must be a whole number
                </mat-error>
              </mat-form-field>
            </div>
            <mat-checkbox
              *ngIf="!flashPointNotApplicableNotVisiable"
              formControlName="flashPointNotApplicable"
              >N/A
            </mat-checkbox>
          </div>
          <div *ngIf="isFlashPointToggle">
            <label>Range</label>
            <mat-form-field appearance="outline" floatLabel="always">
              <mat-select
                formControlName="flashPointRange"
                placeholder="Select Range"
              >
                <mat-option
                  *ngFor="let rangeValue of flashPointRangeOptions.rangeValues"
                  [value]="rangeValue"
                >
                  {{ rangeValue }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="errorHandling('flashPointRange', 'required')">
                Flash Point is <strong>Required</strong>
              </mat-error>
            </mat-form-field>
          </div>
        </span>
      </div>

      <div class="input-container">
        <label>Disposal Consideration</label>
        <mat-radio-group
          fxLayout="column"
          formControlName="disposalConsideration"
        >
          <mat-radio-button
            *ngFor="let disposalConsider of filteredDisposalConsideration"
            [value]="disposalConsider.value"
            name="test"
            >{{ disposalConsider.label }}</mat-radio-button
          >
        </mat-radio-group>
        <div class="mat-form-field-subscript-wrapper">
          <mat-error *ngIf="errorHandling('disposalConsideration', 'required')">
            Disposal Consideration is <strong>Required</strong>
          </mat-error>
        </div>
      </div>
    </div>

    <div class="col">
      <div class="input-container">
        <label>State Approval/ Waste Code</label>
        <mat-form-field appearance="outline">
          <input
            maxlength="12"
            matInput
            formControlName="stateApprovalWasteCode"
          />
          <mat-error *ngIf="stateApprovalWasteCodeErrorHandling()">
            State Approval/ Waste Code is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
        <mat-checkbox formControlName="stateApprovalWasteCodeNotApplicable"
          >Not Applicable (Only if state doesn't issue)
        </mat-checkbox>
      </div>

      <div class="input-container">
        <label>Frequency</label>
        <mat-radio-group fxLayout="column" formControlName="frequency">
          <mat-radio-button value="ongoing"
            >On-Going Waste Stream</mat-radio-button
          >
          <mat-radio-button value="one-time">One-Time Event</mat-radio-button>
        </mat-radio-group>
        <div class="mat-form-field-subscript-wrapper">
          <mat-error *ngIf="errorHandling('frequency', 'required')">
            Frequency is <strong>Required</strong>
          </mat-error>
        </div>
      </div>

      <div class="input-container">
        <label
          >{{ volumeLabel }}
          <mat-icon-button
            mat-icon-button
            class="btn-hint"
            matTooltip="Please do not list a range such as: 20-60 cy. Enter only the higher number"
          >
            <mat-icon class="help-icon">help</mat-icon>
          </mat-icon-button></label
        >
        <mat-form-field appearance="outline" floatLabel="always">
          <input
            maxlength="24"
            matInput
            placeholder="If a range, enter the higher number"
            formControlName="estimatedVolume"
          />
          <mat-error *ngIf="errorHandling('estimatedVolume', 'required')">
            Estimated Volume is <strong>Required</strong>
          </mat-error>
          <mat-error *ngIf="errorHandling('estimatedVolume', 'integer')">
            Please enter integer value
          </mat-error>
          <mat-error *ngIf="errorHandling('estimatedVolume', 'max')">
            Value must be less than or equal to 999999999
          </mat-error>
        </mat-form-field>
      </div>

      <div class="input-container">
        <label>Unit of Measure</label>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-select formControlName="unitOfMeasure" placeholder="Select Unit">
            <mat-option
              *ngFor="let option of streamOptions.options"
              [value]="option"
            >
              {{ option }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="errorHandling('unitOfMeasure', 'required')">
            Unit of Measure is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>

      <div class="input-container">
        <label>Method of Shipment</label>
        <mat-radio-group
          *ngIf="showBagged"
          fxLayout="column"
          formControlName="methodOfShipment"
        >
          <mat-radio-button value="bulk">Bulk</mat-radio-button>
          <mat-radio-button value="drum">Drum</mat-radio-button>
          <mat-radio-button value="bagged">Bagged</mat-radio-button>
          <mat-radio-button value="other">Other</mat-radio-button>
        </mat-radio-group>
        <mat-radio-group
          *ngIf="!showBagged"
          fxLayout="column"
          formControlName="methodOfShipment"
        >
          <mat-radio-button value="bulk">Bulk</mat-radio-button>
          <mat-radio-button value="drum">Drum</mat-radio-button>
          <mat-radio-button value="other">Other</mat-radio-button>
        </mat-radio-group>
        <div class="mat-form-field-subscript-wrapper">
          <mat-error *ngIf="errorHandling('methodOfShipment', 'required')">
            Method of Shipment is <strong>Required</strong>
          </mat-error>
        </div>
      </div>
      <div class="input-container" *ngIf="showOtherShipment">
        <label> Other Method of Shipment </label>
        <mat-form-field appearance="outline">
          <input
            maxlength="24"
            matInput
            placeholder="Describe Other Method"
            formControlName="otherMethodOfShipment"
          />
          <mat-error
            class="error"
            *ngIf="errorHandling('otherMethodOfShipment', 'required')"
          >
            Other Method of Shipment is <strong>Required</strong>
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div class="input-container">
    <label
      >Process Generating Waste
      <mat-icon-button
        mat-icon-button
        class="btn-hint"
        matTooltip="For spill cleanups or contaminated media, the process should identify the potential contaminantsand their source, explain prior site uses (if any), and give the reason the waste is being disposed. For other types of waste,the process must explain how the waste was generated, what materials are involved in the process, and any byproducts that may be generated."
      >
        <mat-icon class="help-icon">help</mat-icon>
      </mat-icon-button>
    </label>
    <mat-form-field appearance="outline">
      <textarea
        maxlength="{{ maxCharCount }}"
        formControlName="processGeneratingWaste"
        matInput
        placeholder="Provide a detailed description of the process or operation that generates the waste."
        matTextareaAutosize
        matAutosizeMinRows="4"
        matAutosizeMaxRows="8"
        (input)="updateCharCount($event)"
      ></textarea>
      <mat-hint align="end">{{ charCount }}/{{ maxCharCount }}</mat-hint>
      <mat-error *ngIf="errorHandling('processGeneratingWaste', 'required')">
        Process Generating Waste is <strong>Required</strong>
      </mat-error>
    </mat-form-field>
    <div class="error-message">
      <mat-icon class="message-bar" *ngIf="charCount >= maxCharCount"
        >error_outline</mat-icon
      >
      <mat-error
        style="font-size: 12px; line-height: 20px"
        *ngIf="charCount >= maxCharCount"
      >
        You have reached the maximum character limit for this field. If you need
        to provide more information, please attach a document as an additional
        supplement in the attachments section of the form.
      </mat-error>
    </div>
  </div>
</form>
